import { UserRole } from '@kfolks/types'

const ROLE_ORDINAL: Record<UserRole, number> = {
	[UserRole.VIEWER]: 0,
	[UserRole.USER]: 1,
	[UserRole.ADMIN]: 2,
	[UserRole.SUPER_ADMIN]: 3,
}

export function roleAtLeast(userRole: UserRole | string | undefined | null, minRole: UserRole): boolean {
	if (userRole === undefined || userRole === null) return false
	const ordinal = ROLE_ORDINAL[userRole as UserRole]
	if (ordinal === undefined) return false
	return ordinal >= ROLE_ORDINAL[minRole]
}

export function isAdmin(role: UserRole | string | undefined | null): boolean {
	return roleAtLeast(role, UserRole.ADMIN)
}
